@use '@design/design-tokens/typography/typography' as *;

.triggerLabel {
  display: flex;
  align-items: center;
  gap: 4px;

  &.hasNavigableOption {
    color: var(--text-primary);
    font-weight: 500;
    justify-content: center;
  }
}

.dropdownLabelContainer {
  display: flex;
  flex-direction: column;
}

.dropdownLabelSubtitle {
  @include typography-v2-body-xs;

  color: var(--text-soft);
}
